import { ReactComponent as DashBoardIcon } from "../assets/svg/workspace/home.svg";
import { ReactComponent as InventoryIcon } from "../assets/svg/workspace/insert-drive-file.svg";
import { ReactComponent as Inventory2Icon } from "../assets/svg/workspace/account-circle.svg";

interface UrlLink {
  id: string;
  label?: string;
  url?: string;
}

export interface NavLink extends UrlLink {
  icon?: React.ReactNode;
}

const _dashboardLinks: NavLink[] = [
  {
    id: "dashboard",
    icon: <DashBoardIcon />,
    label: "Dashboard",
    url: "/dashboard",
  },
  {
    id: "inventory1",
    icon: <InventoryIcon />,
    label: "Inventory-1",
    url: "/inventory1",
  },
  {
    id: "inventory2",
    icon: <Inventory2Icon />,
    label: "Inventory-2",
    url: "/inventory2",
  },
];

export default _dashboardLinks;
